import { FC } from "react";
import { useLocation } from "react-router-dom";

import Container from "@/components/layout/containers/Container";
import Tabs, { TabItemProps } from "@/components/ui/v2/tabs";
import { SidebarItem as SidebarItemType } from "@/types/sidebar/SidebarProps";

type TopNavigationProps = {
  items: SidebarItemType[];
};

function normalizePath(path: string) {
  return (path.startsWith("/") ? path : `/${path}`).toLowerCase();
}

function findActiveItem(items: SidebarItemType[], pathname: string) {
  const currentPath = normalizePath(pathname);
  return items
    .filter((item) => item.path && currentPath.startsWith(normalizePath(item.path)))
    .sort((a, b) => (b.path?.length ?? 0) - (a.path?.length ?? 0))[0];
}

const TopNavigation: FC<TopNavigationProps> = ({ items }) => {
  const location = useLocation();
  const activeItem = findActiveItem(items, location.pathname);

  const tabs: TabItemProps[] = items
    .filter((item) => item.path)
    .map((item) => ({
      id: item.label,
      label: item.label,
      content: <></>,
      href: item.path,
    }));

  return (
    <Container className="flex-row items-center justify-between border-b border-border bg-card dark:bg-background/80 dark:backdrop-blur-sm">
      <div className="flex justify-center overflow-x-auto overflow-y-hidden no-scrollbar">
        <Tabs tabs={tabs} activeTabId={activeItem?.label ?? null} />
      </div>
    </Container>
  );
};

export default TopNavigation;
